import React from "react";
import CardSimple from "screens/components/basic/CardSimple";

const PinPad = () => {
  return (
    <div id="pin-pad-how-to">
      <CardSimple>
        <div className="support-wrapper support-manual">
          <h2>How to use the Pin-Pad Feature</h2>
          <p>
            The Pin-Pad feature is for quick Employee swap on a single terminal,
            only applicable in the POS screen.
          </p>
          <p>
            This feature was made to remove the hassle of logging in
            traditionally, but will require some work and training.
          </p>
          <h3>To activate the Pin-Pad:</h3>
          <ul>
            <li>Go to Admin > Setting</li>
            <img
              src={require("./SupportDocImages/pinpad_images/pin-pad.PNG")}
            />
            <li>
              Find the 'Enable Pin Password?' section, and click to
              activate/deactivate
            </li>
            <img src="http://techpos.ca/support-images/PinPad/PinPad-2.png" />
          </ul>
          <h3>
            Once the Pin-Pad is activated, you must generate Pins for employees
          </h3>
          <ul>
            <li>Go to Menu > Users > Employee</li>
            <img src={require("./SupportDocImages/users_images/users.PNG")} />
            <li>Click 'EDIT' on desired employee</li>
            <img src="http://techpos.ca/support-images/PinPad/PinPad-4.png" />
            <li>
              Find the 'Generate Pin' button and click to give that employee a
              Pin
            </li>
            <img src="http://techpos.ca/support-images/PinPad/PinPad-5.png" />
            <br />
            <img src="http://techpos.ca/support-images/PinPad/PinPad-6.png" />
            <li>Hit Save to attach PIN to Employee</li>
            <img src="http://techpos.ca/support-images/PinPad/PinPad-7.png" />
            <p>
              <strong>NOTE:</strong> Pins can only be done randomly to ensure each employee has a
              unique Pin. You may generate the Pin several times until you find a
              desirable Pin
            </p>
          </ul>
          <h3>How to use the Pin-Pad on the POS screen</h3>
          <ul>
            <p>
              <strong>NOTE:</strong> Only move onto the POS screen once the Pin-Pad is set to active and all working employees have Pins generated and saved to their profile.
            </p>
            <li>Go to Menu > POS Sales</li>
            <li>
              Enter you Pin and proceed with the POS as normal (Refer to How to
              use POS Sales)
            </li>
            <img src="http://techpos.ca/support-images/PinPad/PinPad-8.png" />
          </ul>
        </div>
      </CardSimple>
    </div>
  );
};

export default PinPad;
